<template>
  <div>
    <div class="row mt-3 row-all">
      <div class="col">
        <counterDays />
        <videoTop plase="store" />
        <div class="row pb-2 mt-2">
          <div class="col">
            <TitleAndBorderR class="h1">עסקאות חבילה</TitleAndBorderR>
          </div>
        </div>
        <div class="row">
          <Product v-for="product in productsCategory(1)" :product="product" :key="product.id" />
        </div>
        <div class="row pb-2">
          <div class="col">
            <TitleAndBorderR class="h1">מוצרים</TitleAndBorderR>
          </div>
        </div>
         <div class="row">
          <Product v-for="product in productsCategory(2)" :product="product" :key="product.id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import counterDays from '@/components/counterDays.vue'
  import Product from '@/components/Product.vue'
  import videoTop from '@/components/videoTop.vue'
  import TitleAndBorderR from '@/components/TitleAndBorderR.vue'


  export default {
    name: 'Store',
    components: {
      Product,
      counterDays,
      videoTop,
      TitleAndBorderR
    },
    data() {
      return {

      }
    },
    mounted() {
       this.$store.dispatch('fbApi', {
        event_name: "ViewContent",
        event_time: Math.floor(new Date() / 1000),
        value: 0,
      })
      // this.$store.commit('upAutoModel', {routeName: this.$route.name, seconds: 5000})
    },
    methods: {
      productsCategory(categoryId) {
        return this.$store.state.products.filter((el)=> {
          return el.category === categoryId  
        })
      }
    },
    computed: {
      products() {
        return this.$store.state.products
      }
    },
  }
</script>

<style scoped>
  .row-all {
    padding: 0% 15%;
  }

  p {
    font-size: 20px;
  }

  .more {
    color: rgb(134, 134, 134);
    cursor: pointer;
  }

  .butt-oper {
    cursor: pointer;
  }

  button {
    border: none;
    background-color: black;
    color: #ffffff;
    padding: 10px;
    outline: none;
  }

  .box-all {
    padding: 0px;
  }

  .box-product {
    box-shadow: 1px 1px 3px #c1c1c1;
    margin: 15px;
    padding: 17px;
  }

  @media (max-width: 767.98px) {
    .row-all {
      padding: 0% 0%;
    }
  }
</style>